import React from 'react'
import underConstruction from '../images/PageUnderConstruction.png'

const HomeLoan = () => {
  return (
    <section>
      <div className='container text-center'>
        <img src={underConstruction} className='undrcnstrctn' />
      </div>
    </section>
  )
}

export default HomeLoan
